export async function mfetch(url, data = {}, timeoutDuration = 5000) {
    const headers = new Headers();
    const controller = new AbortController(); // Create an AbortController for the fetch request
    const signal = controller.signal; // Get the signal from the controller

    // Create a timeout promise that rejects after the specified duration
    const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
            controller.abort(); // Abort the fetch request
            reject({
                error: 'Request timed out',
                status: 408, // HTTP status code for request timeout
            });
        }, timeoutDuration);
    });

    // Execute the fetch request
    const fetchPromise = fetch(url, { method: 'POST', headers: headers, body: toFormData(data), signal })
        .then(response => response.text())
        .then(response => {
            if (response.startsWith('<!DOCTYPE')) {
                return { status: 404, error: 'Connection Error' };
            }
            response = JSON.parse(response);
            if (response.status === 200) {
                return response.data;
            }
            return {
                status: response.status ?? 500,
                error: response.message ?? "Invalid Response",
            };
        })
        .catch(error => {
            if (signal.aborted) {
                return {
                    error: 'Request aborted',
                    status: 500,
                };
            }
            return {
                error: 'An error has occurred',
                status: 500,
            };
        });

    // Use Promise.race to handle either the timeout or fetch completion first
    return Promise.race([timeoutPromise, fetchPromise]);

    // return await fetch(url, { method: 'POST', headers: headers, body: toFormData(data) })
    //     .then(response => response.text())
    //     .then(response => {
    //         if (response.startsWith('<!DOCTYPE')) return { status: 404, error: 'Connection Error' }
    //         response = JSON.parse(response);
    //         if (response.status === 200) return response.data;
    //         return ({
    //             status: response.status ?? 500,
    //             error: response.message ?? "Invalid Response"
    //         })
    //     })
    //     .catch(error => { return { error: 'An error has occur', status: 500 } });
}

export function toFormData(obj) {
    let formData = new FormData();
    Object.keys(obj).map(key => formData.append(key, obj[key]));
    return formData;
}
